import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	TGpsrStore,
	TGpsrProductTypesResponsePayload,
	TGpsrSkuResponsePayload,
	TGpsrStatusResponsePayload,
	TGpsrAttachSkuResponsePayload,
	TGpsrAdditionalInformationResponsePayload,
	TGpsrPlansResponsePayload,
} from './types';

// ==========================================:
const getGpsrState = (state: TStoreState): TGpsrStore => state.gpsr;
export const getGpsr = getGpsrState;

// ====================================================:
export const getGpsrStatus = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): TGpsrStatusResponsePayload => gpsr.gpsrStatus,
);

// ====================================================:

export const getGpsrStatusIsLoad = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): boolean => gpsr.gpsrStatusLoading,
);

// ====================================================:

export const getGpsrProductTypes = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): TGpsrProductTypesResponsePayload => gpsr.gpsrProductTypes,
);

// ====================================================:

export const getGpsrProductTypesIsLoad = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): boolean => gpsr.gpsrProductTypesLoading,
);

// ====================================================:

export const getGpsrSkus = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): TGpsrSkuResponsePayload => gpsr.gpsrSkus,
);

// ====================================================:

export const getGpsrSkusIsLoad = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): boolean => gpsr.gpsrSkusLoading,
);

// ====================================================:

export const getGpsrAttachSkuIsLoad = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): boolean => gpsr.gpsrAttachSkuLoading,
);

// ====================================================:

export const getGpsrAttachSkuMessage = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): TGpsrAttachSkuResponsePayload => gpsr.gpsrAttachSkuMessage,
);

// ====================================================:

export const getGpsrDeleteSkuIsLoad = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): boolean => gpsr.gpsrDeleteSkuLoading,
);

// ====================================================:

export const getGpsrGenerateDocIsLoad = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): boolean => gpsr.gpsrGenerateDocLoading,
);

// ====================================================:

export const getGpsrUploadDocIsLoad = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): boolean => gpsr.gpsrUploadDocLoading,
);

// ====================================================:

export const getGpsrDownloadDocIsLoad = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): boolean => gpsr.gpsrDownloadDocLoading,
);

// ====================================================:

export const getGpsrUploadTechFileIsLoad = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): boolean => gpsr.gpsrUploadTechFileLoading,
);

// ====================================================:

export const getGpsrGetTechFileIsLoad = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): boolean => gpsr.gpsrGetTechFileLoading,
);

// ====================================================:

export const getGpsrAdditionalInformation = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): TGpsrAdditionalInformationResponsePayload => gpsr.gpsrAdditionalInformation,
);

// ====================================================:

export const getGpsrAdditionalInformationIsLoad = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): boolean => gpsr.gpsrAdditionalInformationLoading,
);

// ====================================================:

export const getGpsrCancellationIsLoad = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): boolean => gpsr.gpsrCancellationLoading,
);

// ====================================================:

export const getGpsrPlans = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): TGpsrPlansResponsePayload => gpsr.gpsrPlans,
);

// ====================================================:

export const getGpsrPlansIsLoad = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): boolean => gpsr.gpsrPlansLoading,
);

// ====================================================:

export const getGpsrChangeServiceIsLoad = createSelector(
	[getGpsr],
	(gpsr: TGpsrStore): boolean => gpsr.gpsrChangeServiceLoading,
);
